export default "__VITE_ASSET__CMUA8qKp__"